import {get} from 'lodash';

export default (state: any, {isLoading}: any) => ({
  ...state,
  supportedLanguages: {
    ...get(state, 'supportedLanguages', {}),
    isLoading,
  },
});
